// ============================================================================
// Supabase Module Exports
// ============================================================================

// Client utilities
export {
  getBrowserClient,
  getServerClient,
  getServerClientWithAuth,
  getUntypedServerClient,
  getSession,
  getUser,
  signOut,
} from './client';

// Auth context and hooks
export {
  AuthProvider,
  useAuth,
  hasRole,
  isOwner,
  isOwnerOrManager,
  canAccessRoute,
} from './auth-context';

// Types
export type {
  // Enums
  UserRole,
  BookingStatus,
  ConfirmationStatus,
  PaymentMethod,
  PaymentStatus,
  SaleRuleType,
  AlertStatus,
  // Row types
  Profile,
  Business,
  StaffMember,
  Service,
  Customer,
  Booking,
  BookingService,
  Payment,
  SalesRule,
  AutomationRule,
  Alert,
  InboxMessage,
  Notification,
  BusinessHours,
  Preferences,
  // Insert types
  ProfileInsert,
  BusinessInsert,
  StaffMemberInsert,
  ServiceInsert,
  CustomerInsert,
  BookingInsert,
  BookingServiceInsert,
  PaymentInsert,
  // Update types
  ProfileUpdate,
  BusinessUpdate,
  BookingUpdate,
  CustomerUpdate,
  // Joined types
  BookingWithDetails,
  CustomerWithActivity,
  StaffMemberWithProfile,
  // Database schema
  Database,
} from './types';

